/* global axios */
import ApiClient from './ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }

  duplicate(formId) {
    return axios.post(`${this.url}/${formId}/duplicate`);
  }

  publish(formId) {
    return axios.post(`${this.url}/${formId}/publish`);
  }

  archive(formId) {
    return axios.post(`${this.url}/${formId}/archive`);
  }

  getSubmissions(formId, params) {
    return axios.get(`${this.url}/${formId}/form_submissions`, { params });
  }
}

export default new FormsAPI();
